import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
interface Destination {
  id: string;
  name: string;
  country: string;
  image: string;
  hotels: number;
  description: string;
  hash: string;
}
const destinations: Destination[] = [{
  id: '1',
  name: 'Dubai',
  country: 'United Arab Emirates',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80',
  hotels: 1250,
  description: 'Luxury shopping, ultramodern architecture & vibrant nightlife',
  hash: 'dubai'
}, {
  id: '2',
  name: 'Kathmandu',
  country: 'Nepal',
  image: 'https://images.unsplash.com/photo-1558799401-1dcba79834c2?w=800&q=80',
  hotels: 480,
  description: 'Ancient temples, stunning Himalayas & rich cultural heritage',
  hash: 'kathmandu'
}, {
  id: '3',
  name: 'Paris',
  country: 'France',
  image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80',
  hotels: 2100,
  description: 'Iconic landmarks, world-class cuisine & romantic ambiance',
  hash: 'france'
}, {
  id: '4',
  name: 'New Delhi',
  country: 'India',
  image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=800&q=80',
  hotels: 890,
  description: 'Historic monuments, diverse cuisine & vibrant markets',
  hash: 'delhi'
}];
export function TrendingDestinations() {
  return <section className="py-16 lg:py-24 bg-white" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-239">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-240">
            Popular Destinations
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="w-20 h-1 bg-travel-turquoise-500 mx-auto rounded-full" data-id="element-241" />
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-242">
            Explore the world's most sought-after travel destinations
          </motion.p>
        </div>

        {/* Destinations Grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-243">
          {destinations.map((destination, index) => <motion.a key={destination.id} href={`#${destination.hash}`} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`group relative overflow-hidden rounded-2xl ${index === 0 ? 'md:col-span-2 md:row-span-2' : ''}`} whileHover={{
          y: -4
        }} data-id="element-244">
              <div className={`relative ${index === 0 ? 'aspect-square md:aspect-auto md:h-full min-h-[400px]' : 'aspect-[4/3]'}`} data-id="element-245">
                {/* Image */}
                <img src={destination.image} alt={destination.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-246" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" data-id="element-247" />

                {/* Content */}
                <div className="absolute inset-0 p-6 flex flex-col justify-end" data-id="element-248">
                  <div className="flex items-center gap-1 text-travel-turquoise-400 mb-2" data-id="element-249">
                    <MapPin className="w-4 h-4" data-id="element-250" />
                    <span className="text-sm font-medium" data-id="element-251">
                      {destination.country}
                    </span>
                  </div>

                  <h3 className={`font-bold text-white mb-2 ${index === 0 ? 'text-3xl md:text-4xl' : 'text-xl'}`} data-id="element-252">
                    {destination.name}
                  </h3>

                  <p className={`text-white/80 mb-3 ${index === 0 ? 'text-base' : 'text-sm'} line-clamp-2`} data-id="element-253">
                    {destination.description}
                  </p>

                  <div className="flex items-center justify-between" data-id="element-254">
                    <span className="text-sm text-white/70" data-id="element-255">
                      {destination.hotels.toLocaleString()} hotels
                    </span>
                    <span className="flex items-center gap-1 text-travel-turquoise-400 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-256">
                      Explore <ArrowRight className="w-4 h-4" data-id="element-257" />
                    </span>
                  </div>
                </div>
              </div>
            </motion.a>)}
        </motion.div>
      </div>
    </section>;
}